module.exports = __webpack_public_path__ + "img/s-afrika_m.e6623776.jpg";